import React, { useState, useEffect, FC } from 'react';
import _ from 'lodash';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Text } from '@wix/design-system';
import { MAX_CHARS_IN_REVIEW } from '@utils/constants';
import ShowMoreText from '../../ShowMoreText';
import ReviewReplyDialogue from '../ReviewReplyDialogue';
import { ReviewProps } from '../types';
import s from './Review.module.scss';

const Review: FC<ReviewProps> = ({
  review,
  isMyProfile,
  services,
  i18nKeys: { replyAuthorTitle },
  handleBiGenericClick,
  isMobileView,
  replyProps,
  ReviewHeader = () => <Box />,
  reviewStyles,
}) => {
  const { t } = useTranslation();
  const [serviceName, setServiceName] = useState<string>('');

  useEffect(() => {
    if (services && review) {
      const service = services.find((item) => item?.id === review.serviceId);
      if (_.get(service, 'displayKey')) {
        setServiceName(t(`explore.services.${service?.displayKey}`));
      }
    }
  }, [services, review, t]);

  if (!review) {
    return <></>;
  }

  return (
    <Box
      display="block"
      dataHook="review-container"
      overflow="hidden"
      maxWidth="828px"
      width="100%"
      padding="2px"
    >
      <ReviewHeader review={review} />
      <Box display="block">
        <ShowMoreText
          dataHookPrefix="review-"
          originalText={review?.text}
          maxChars={MAX_CHARS_IN_REVIEW}
          handleShowMoreClick={() =>
            handleBiGenericClick?.({ clickType: 'show more reviews' })
          }
          textSize={reviewStyles?.textSize}
          inlineButton
          buttonWeight="thin"
        />
      </Box>
      {serviceName && (
        <Text
          className={s.servicesPadding}
          size="small"
          weight="thin"
          light
          secondary
          tagName="div"
          dataHook="review-service-name"
        >
          {t('profile-page-review-service-text', { serviceName })}
        </Text>
      )}
      <ReviewReplyDialogue
        review={review}
        replyAuthorTitle={replyAuthorTitle}
        isMyProfile={isMyProfile}
        isMobileView={isMobileView}
        handleBiGenericClick={handleBiGenericClick}
        {...replyProps}
      />
    </Box>
  );
};

export default Review;
